import { render, staticRenderFns } from "./article_simple_sel_page.vue?vue&type=template&id=58f73208&scoped=true"
import script from "./article_simple_sel_page.vue?vue&type=script&lang=js"
export * from "./article_simple_sel_page.vue?vue&type=script&lang=js"
import style0 from "./article_simple_sel_page.vue?vue&type=style&index=0&id=58f73208&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f73208",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58f73208')) {
      api.createRecord('58f73208', component.options)
    } else {
      api.reload('58f73208', component.options)
    }
    module.hot.accept("./article_simple_sel_page.vue?vue&type=template&id=58f73208&scoped=true", function () {
      api.rerender('58f73208', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/article_simple_sel_page.vue"
export default component.exports